import { connect, useDispatch, useSelector } from "react-redux";
import {
  FeaturedAdsCreateProps,
  FeaturedVideoFolderId,
  stateStatusType,
  UploadFeaturedAdsVideoInput,
} from "../state/actionType";
import { ResetFeaturedAds, uploadFeaturedAdsVideo } from "../state/action";
import { FormEvent, useEffect, useState } from "react";
import { ApiError, CancelButton, SubmitButton } from "components";
import { showSnackbar } from "utils/snack_bar/store/action";
import { ClientPayloadProps } from "modules/video/video_detail/store/actionType";
import { AppDispatch } from "index";

interface OwnProps {
  onClose: () => void;
  videoFile: File | null;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUploadFeaturedAdsVideo: React.FC<Props> = ({
  onUploadFeaturedAdsVideo,
  onResetFeaturedAds,
  onClose,
  videoFile,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const featuredAdsState = useSelector(
    (state: any) => state.featuredAds.genericFeaturedAdsState
  );
  const featuredAdsVideoState = useSelector(
    (state: any) => state.featuredAds.featuredAdsState
  );
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const [featuredAdsData, setFeaturedAdsData] = useState<FeaturedAdsCreateProps>(
    {} as FeaturedAdsCreateProps
  );
  useEffect(() => {
    const stored = localStorage.getItem("featuredAds");
    if (stored) {
      setFeaturedAdsData(JSON.parse(stored));
    }
  }, []);
  const handleUpload = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const input: UploadFeaturedAdsVideoInput = {
      title: featuredAdsData?.featuredAd?.name,
      folder_id: FeaturedVideoFolderId,
      create_video_id: featuredAdsData?.featuredAd?.id?.toString(),
    };
    onUploadFeaturedAdsVideo(input);
    setSubmitted(true);
    setLoading(false);
  };
  useEffect(() => {
    onResetFeaturedAds();
  }, []);
  useEffect(() => {
    if (!featuredAdsState.isLoading && submitted) {
      if (featuredAdsState.error) {
        setApiError(featuredAdsState.error); // show error
      } else {
        setApiError(null);
        onResetFeaturedAds();
        onClose();
      }
    }
  }, [featuredAdsState.isLoading, featuredAdsState.error, submitted]);
  useEffect(() => {
    const uploadVideo = async () => {
      const uploadUrl: ClientPayloadProps =
        featuredAdsVideoState?.featuredAdsVideo;
      const url = uploadUrl?.uploadLink;
      // console.warn("Missing URL or video file");
      if (!url || !videoFile) return;

      const formDataUpload = new FormData();
      formDataUpload.append("key", uploadUrl.key);
      formDataUpload.append("success_action_status", "201");
      formDataUpload.append("success_action_redirect", "");
      formDataUpload.append("policy", uploadUrl.policy);
      formDataUpload.append("x-amz-algorithm", uploadUrl.x_amz_algorithm);
      formDataUpload.append("x-amz-credential", uploadUrl.x_amz_credential);
      formDataUpload.append("x-amz-date", uploadUrl.x_amz_date);
      formDataUpload.append("x-amz-signature", uploadUrl.x_amz_signature);
      formDataUpload.append("file", videoFile);

      try {
        const response = await fetch(url, {
          method: "POST",
          body: formDataUpload,
        });
        if (!response.ok) {
          throw new Error("video upload failed");
        }

        dispatch(showSnackbar("Video uploaded successfully!"));
      } catch (err: any) {
        console.error("Upload error", err);
        setApiError("Video upload failed: " + err.message);
      }
    };
    if (featuredAdsState.status === stateStatusType.SUCCESS && submitted) {
      uploadVideo();
    }
  }, [featuredAdsState.status, featuredAdsState.featuredAdsVideo, submitted]);
  return (
    <>
      {featuredAdsData && (
        <div className="flex justify-center items-center flex-col">
          <div className="my-5 text-primary-500">
            <h4 className="text-2xl mb-3">
              You are uploading <strong>{featuredAdsData?.featuredAd?.name}</strong>
            </h4>
            <p className="text-lg">Press continue to upload the video</p>
          </div>
          {apiError && <ApiError>{apiError}</ApiError>}
          <div className="w-full flex justify-between px-5 items-center">
            <CancelButton onClick={onClose} />
            <SubmitButton
              onClick={handleUpload}
              loading={loading}
              loadingText="uploading..."
            >
              Continue Uploading
            </SubmitButton>
          </div>
        </div>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUploadFeaturedAdsVideo: (input: UploadFeaturedAdsVideoInput) =>
    dispatch(uploadFeaturedAdsVideo(input)),
  onResetFeaturedAds: () => dispatch(ResetFeaturedAds()),
});
export default connect(null, mapDispatchToProps)(HandleUploadFeaturedAdsVideo);
